import React, { useState, useEffect } from "react";

import { DefaultImageBaseurl, endPoints } from "../constant/Environment";
import { getAllData, getAllFilterData } from "../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Toaster from "../components/Toast";
import Loader from "../components/Loader";
import { ErrorToast, SuccesToast } from "../components/Toast/message";
import moment from "moment-timezone";
import { Col, Row, Container } from "react-bootstrap";
import canceicon from "../assests/payments_icon/cancel.png";
const CancelModal = (props) => {
  const [cancelShow, setCancelShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { setSelectedData, selectedData } = props;
  const handleViewClose = () => {
    setCancelShow(false);
  };

  const CancelRequest = async () => {
    try {
      let url = `${endPoints.api.UPDATE_SOCIAL_POST}`;
      let data = {
        id: selectedData.id,
        id_user: selectedData.id_user,
        status: 2,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);

        setCancelShow(false);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <img
        src={canceicon}
        style={{ height: "30px" }}
        onClick={() => {
          setSelectedData();
          setCancelShow(true);
        }}
      />

      <Modal
        show={cancelShow}
        onHide={handleViewClose}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ fontSize: "24px", fontWeight: "bold" }}
        >
          Request Cancellation
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Toaster></Toaster>
              {isLoading && <Loader spinner={true} visible={isLoading} />}
              <Col xs={12}>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th>Customer ID:</th>
                      <td>{selectedData?.id_user}</td>
                      <th>Customer Name:</th>
                      <td>{selectedData?.name}</td>
                    </tr>
                    <tr>
                      <th>Offer Name:</th>
                      <td>{selectedData?.offerName}</td>
                      <th>Post Url:</th>
                      <td>{selectedData?.post_url}</td>
                    </tr>
                    <tr>
                      <th>Gold Coin :</th>
                      <td>{selectedData?.goldCoin}</td>
                    </tr>
                  </tbody>
                </table>
                <div style={{display:'flex',justifyContent:'center'}}>
                <img
                  src={`${DefaultImageBaseurl}${selectedData.post_image}`}
                  style={{ height: '200px' }}
                />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="text-center">
                <p>
                  <b style={{ fontSize: "20px" }}>
                    Would you like to Cancel this request?
                  </b>
                </p>
                {/* <p style={{ fontSize: "12px" }}>
                  After cancellation coi will be returned to the player’s
                  account.
                </p> */}
                <Button
                  variant="primary"
                  size="lg"
                  block
                  style={{
                    borderRadius: "8px",
                    background: "#ED0100",
                    border: "none",
                  }}
                  onClick={() => {
                    CancelRequest();
                  }}
                >
                  Cancel Request
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CancelModal;
